import { Injectable, ErrorHandler } from '@angular/core';
import {
  HttpInterceptor, HttpRequest,
  HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppService } from '@app/services/app/app.service';
import { MainHttpErrorResponse } from "@core/classes/main-http-error-response.class"

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {

    constructor(private app: AppService, private errHandler: ErrorHandler) {
    }

    intercept( req: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {

      return next.handle(req).pipe(
        tap({
          next:(data: any) => {
              //console.log(data);
              //this.app.setLogged(true);
          },
          error:(err: any) => {
              // just handle the HttpErrorResponse errors here.
              if (err instanceof HttpErrorResponse) {
                  //console.log("llega el error status ", err.status);
                  console.log('req url :: ' + JSON.stringify(err));
                  this.app.setHttpError(err.status);
                  // switch (err.status) {
                  //   case 401: // not logged
                  //     this.app.setLogged(false);
                  //     break;
                  //   case 509: // too many sessions
                  //     this.app.sendTooManySessions();
                  //     break;
                  // }
                  try {
                    // Parse the JSON string or get error message
                    const parsedError = err.error != null ? JSON.parse(err.error) : err.message;
                
                    // Set the message property
                    const message = parsedError.message ? parsedError.message : parsedError;
                    // send our MainHttpErrorResponse to sentry 
                    this.errHandler.handleError(new MainHttpErrorResponse(message, {
                      level: 'error',
                      tags: {
                        module: 'HttpResponseInterceptor',
                        feature: 'ErrorHandling'
                      },
                      extra: {
                        url: req.url,
                        method: req.method,
                        status: err.status,
                        errorMessage: err.message || 'No extra message provided'
                      }
                    }));
                  } catch (error) {
                    const altMsg = `Error processing HTTP request to URL: ${req.url}.`;
                    // Sentry.captureMessage(
                    this.errHandler.handleError(new MainHttpErrorResponse(  altMsg, {
                      level: 'error',
                      tags: {
                        module: 'HttpResponseInterceptor',
                        feature: 'ErrorHandling'
                      },
                      extra: {
                        url: req.url,
                        method: req.method || '',
                        status: err.status || 0,
                        errorMessage: err.message || 'No extra message provided'
                      }
                    }));
                  }
              }
          }
        })
      );

    }

}
